
async function fetchConfig(baseURL: string) {

    try {
      const request = await fetch(
        baseURL + '/Sps/config',
        {
          method: 'GET',
          mode: 'no-cors',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json', 
          }
        }
      );

      const text = await request.text();
      
      if (text === 'sesout') {
        window.location.href = baseURL + '/user/login';
        throw new Error('Session timeout');
        
      }

      const json = JSON.parse(text);

      return json;

      

    } catch (e) {
      console.log(e)
    }

  }

  export default fetchConfig;